import { Button } from '@design-system/button';
import { SuccessModal } from '@phx-husky/common-components';
import { useProfile } from '@phx-husky/use-profile';
import { useTranslations } from '@phx-husky/use-translations';
import classNames from 'classnames';
import React, { useState } from 'react';

import { Form } from '../form';
import { ChangeEmailProps } from '../models';
import * as sectionStyles from './user-details-section.module.scss';

export const ChangeEmail = ({
  fields,
  editButtonDisabled,
  formVisible,
  setFormVisible,
}: ChangeEmailProps) => {
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const { changeEmail } = useProfile();
  const { translate } = useTranslations();

  const onSuccess = () => {
    setSuccessModalVisible(true);
  };

  const onModalClose = () => {
    setSuccessModalVisible(false);
  };

  const onSubmit = async (params: { email: string; loginPassword: string }) =>
    changeEmail({
      newEmail: params.email,
      password: params.loginPassword,
    });

  return (
    <>
      {formVisible ? (
        <Form
          fields={fields}
          onSubmit={onSubmit}
          onSuccess={onSuccess}
          onClose={() => setFormVisible(false)}
          cancelButtonLabel={translate('userDetailsChangeEmailCancelButton')}
          submitButtonLabel={translate('userDetailsChangeEmailSubmitButton')}
          closeButtonVisible
        />
      ) : (
        <div
          className={classNames(
            sectionStyles.buttonWrapper,
            'auth-profile-section__button-wrapper'
          )}
        >
          <Button
            variant="primary"
            className={classNames(
              sectionStyles.button,
              'auth-profile-section__button-edit'
            )}
            type="button"
            onClick={() => setFormVisible(true)}
            disabled={editButtonDisabled}
          >
            {translate('userDetailsChangeEmailSubmitButton')}
          </Button>
        </div>
      )}
      <SuccessModal
        isShowing={successModalVisible}
        title={translate('userDetailsChangeEmailSuccessModalTitle')}
        body={translate('userDetailsChangeEmailSuccessModalMessage')}
        closeButtonLabel={translate('userDetailsChangeEmailSuccessModalButton')}
        onClose={onModalClose}
      />
    </>
  );
};
